import React, { useState } from "react";
import * as s from "./index.module.scss";
import BG from "../../../images/Hero/bg.png";
import { IoArrowForward } from "react-icons/io5";
import Link from "next/link";
import secondaryFont from "@/utils/secondaryFont";
import { PrismicRichText } from "@prismicio/react";
import Popups from "../Popups";
import { PrismicNextImage } from "@prismicio/next";

const HeroV3 = ({
  backgroundImage = { BG },
  backgroundImageAlt = { BG },
  viewMore = false,
  viewMoreLink = "",
  caption = "",
  title = "Luxury Watches Title",
  description = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  visibility = false,
  page = "",
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section className={s.hero}>
      <div className={s.hero_wrapper}>
        <div className={s.background_image_container}>
          <PrismicNextImage field={backgroundImage} fallbackAlt="" />
        </div>
        <div className={s.hero_content_wrapper}>
          <div className={"container"}>
            <div className={s.text_container}>
              <div className={`mb-3 fw-bold ${s.title}`}>
                <PrismicRichText field={title} />
              </div>
              <div className="mb-4 fw-normal paragraph">
                {/* {description} */}
                <PrismicRichText field={description || []} />
              </div>
            </div>
            <div className={s.button_container}>
              <button
                className={`btn btn-primary mb-3 mb-lg-0 me-md-4 d-block d-lg-inline ${secondaryFont}`}
                onClick={() => {
                  setShowModal(true);
                }}
              >
                Get an offer now{" "}
                <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
              </button>
              {visibility && viewMore && (
                <Link
                  href={viewMoreLink}
                  className={`btn btn-outline-dark ${secondaryFont}`}
                >
                  visibility && View More{" "}
                  <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
      <Popups
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        page={page}
      />
    </section>
  );
};

export default HeroV3;
